<!-- =========================================================================================
    File Name: UserFile.vue
    Description: User File page
========================================================================================== -->

<template>
  <div>
    <user-file-sidebar :isSidebarActive="dataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"  />
    <vx-card class="overflow-auto">
      <vs-button icon-pack="feather" icon="icon-download" @click="exportExcel()">{{$t('EXPORT_EXCEL')}}</vs-button>
      <v-server-table id="user-file-table" ref="userFileTable" name="userFileTable" 
        :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcel">
        <vs-chip slot="s3UploadYn" slot-scope="props" :color="getS3UploadResultColor(props.row.userFile.s3UploadYn)" class="w-full" >
          {{$t(setS3UploadResult(props.row.userFile.s3UploadYn))}}</vs-chip>
        <div slot="detail" slot-scope="props">
            <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="seeDetail(props.row)" />
        </div>
      </v-server-table>
    </vx-card>
  </div>
</template>

<script>
let FileSaver = require('file-saver');

import UserFileSidebar from './UserFileSidebar.vue'
import moduleUserFile from "@/store/userFile/moduleUserFile.js"

export default {
  components: {
    UserFileSidebar
  },
  data() {
    return {
      // Data Sidebar
      dataSidebar: false,
      sidebarData: {},

      // Excel
      filter: {},
      sorted:{},
      
      // Table
      columns: [ 'seq','userId', 'deviceUUID', 'fileName', 's3UploadYn', 'downloadCount','detail'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: [ 'seq','userId', 'deviceUUID', 'fileName', 's3UploadYn', 'downloadCount'],
        sortable: ['seq','userId', 'deviceUUID', 'fileName', 's3UploadYn', 'downloadCount'],
        orderBy: { ascending: false },
        debounce: 1000,
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
          filterBy: this.$t("FILTER_BY"),
          defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'seq' : () => this.$t("FILE_SEQ"),
          'userId' : () => this.$t("USER_ID"),
          'deviceUUID': () => this.$t("DEVICE_UUID"),
          'fileName': () => this.$t("FILE_NAME"),
          's3UploadYn':() => this.$t("S3_UPLOAD_YN"),
          'downloadCount' : () => this.$t("DOWNLOAD_COUNT"),
          'detail': () => this.$t("DETAIL"),
        },
        listColumns:{
          s3UploadYn:[
            {
              id: 'Y',
              text: this.$t("UPLOADED")
            },
            {
              id: 'N',
              text: this.$t("NOT_UPLOADED")
            },
            {
              id: 'E',
              text: this.$t("UPLOAD_ERROR")
            },
          ],
          downloadCount:[
            {
              id: '0',
              text: '0'
            },
            {
              id: '1',
              text: '1'
            },
            {
              id: '2',
              text: '2'
            },
            {
              id: '3',
              text: '3'
            },
            {
              id: '4',
              text: '4'
            },
            {
              id: 5,
              text: '5'
            }
          ],
        },
        columnsClasses: {
          seq: 'userfile-seq',
        },
        requestAdapter: function(data) {
          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "userId",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        requestFunction: function (data) {
          return this.$http.get('/api/user-file-management/user-file', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataUserFile/SET_USER_FILE',response.data)
          return {
            data: this.$store.state.dataUserFile.userFileList,
            count: this.$store.state.dataUserFile.userFileListCount
          }
        },
        templates:{
          seq: function(h,row){
            return row.userFile.seq;
          },
          userId: function(h,row){
            return row.user.userId;
          },
          deviceUUID: function(h,row){
            return row.userFile.deviceUUID;
          },
          fileName: function(h,row){
            return row.userFile.fileName;
          },
          downloadCount: function(h,row){
            return row.userFile.downloadCount;
          }
        }
      }
    }
  },
  created() {
    if (!moduleUserFile.isRegistered) {
      this.$store.registerModule('dataUserFile', moduleUserFile)
      moduleUserFile.isRegistered = true
    }
  },
  mounted(){
     if (this.$route.params.userId) {
        this.setFilterForExcel({
          name: "userId",
          value: this.$route.params.userId
        })
        this.$refs.userFileTable.setFilter({
          userId: this.$route.params.userId
        })
     }
  },
  methods: {
    // Sidebar
    toggleDataSidebar(val=false) {
      this.dataSidebar = val
    },
    seeDetail(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    setS3UploadResult(result){
      if (result === "Y") return "UPLOADED"
      if (result === "N") return "NOT_UPLOADED"
      if (result === "E") return "UPLOAD_ERROR"
    },
    getS3UploadResultColor(result) {
      if (result === "Y") return "primary"
      if (result === "N") return "danger"
      if (result === "E") return "warning"
    },
    exportExcel(){
      
      let locale = this.$i18n.locale

      this.$http({
        method: 'post',
        url: '/api/user-file-management/user-file/excel/'+locale,
        data:{
          query : JSON.stringify(this.filterForExcel),
          orderBy:  this.sortForExcel.column ? this.sortForExcel.column : 'userId' ,
          ascending: this.sortForExcel.ascending ? 1 : 0
        },
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then((response) => {
        let excelTitle
        if (locale === "ko") {
          excelTitle = "고객_파일_목록.xlsx"
        } else {
          excelTitle ="User_File_List.xlsx"
        }
        FileSaver.saveAs(response.data, excelTitle)
      }).catch((error)=> {
        console.log(error);
      }) 
    }
  }, 
}

</script>

<style lang="scss" scoped>
#user-file-table {
  text-align: center;
}
</style>